var _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapIndicator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 366,
    height: 318,
    viewBox: "0 0 366 318",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 354.416,
    cy: 237.635,
    r: 7.14849,
    transform: "rotate(76.6118 354.416 237.635)",
    fill: "white",
    stroke: "#E52823",
    strokeWidth: 4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.6871,
    cy: 97.8056,
    r: 32.1223,
    transform: "rotate(76.6118 38.6871 97.8056)",
    fill: "#E52823"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapIndicator);
export default __webpack_public_path__ + "static/media/map-indicator.97354bc2398f7965d5e0d60349eb984d.svg";
export { ForwardRef as ReactComponent };